// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GiLU","footer":"styles_footer__29rYP","passCodeTooltip":"styles_passCodeTooltip__3U8ag"};